/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { ServiceCategory } from '../models/service-category';
import { ServiceCategoryListResponse } from '../models/service-category-list-response';
import { serviceControllerCreate } from '../fn/services/service-controller-create';
import { ServiceControllerCreate$Params } from '../fn/services/service-controller-create';
import { serviceControllerCreateCategory } from '../fn/services/service-controller-create-category';
import { ServiceControllerCreateCategory$Params } from '../fn/services/service-controller-create-category';
import { serviceControllerDelete } from '../fn/services/service-controller-delete';
import { ServiceControllerDelete$Params } from '../fn/services/service-controller-delete';
import { serviceControllerDeleteCategory } from '../fn/services/service-controller-delete-category';
import { ServiceControllerDeleteCategory$Params } from '../fn/services/service-controller-delete-category';
import { serviceControllerFindOne } from '../fn/services/service-controller-find-one';
import { ServiceControllerFindOne$Params } from '../fn/services/service-controller-find-one';
import { serviceControllerGetAllCategories } from '../fn/services/service-controller-get-all-categories';
import { ServiceControllerGetAllCategories$Params } from '../fn/services/service-controller-get-all-categories';
import { serviceControllerRenameCategory } from '../fn/services/service-controller-rename-category';
import { ServiceControllerRenameCategory$Params } from '../fn/services/service-controller-rename-category';
import { serviceControllerUpdate } from '../fn/services/service-controller-update';
import { ServiceControllerUpdate$Params } from '../fn/services/service-controller-update';
import { ServiceItem } from '../models/service-item';
import { ServiceItemWithCategory } from '../models/service-item-with-category';

@Injectable({ providedIn: 'root' })
export class ServicesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `serviceControllerGetAllCategories()` */
  static readonly ServiceControllerGetAllCategoriesPath = '/service/category';

  /**
   * Restituisce l'elenco delle categorie e dei suoi servizi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceControllerGetAllCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceControllerGetAllCategories$Response(params?: ServiceControllerGetAllCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceCategoryListResponse;
}>> {
    return serviceControllerGetAllCategories(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle categorie e dei suoi servizi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceControllerGetAllCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceControllerGetAllCategories(params?: ServiceControllerGetAllCategories$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ServiceCategoryListResponse;
}> {
    return this.serviceControllerGetAllCategories$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ServiceCategoryListResponse;
}>): BaseResponse & {
'data'?: ServiceCategoryListResponse;
} => r.body)
    );
  }

  /** Path part for operation `serviceControllerCreateCategory()` */
  static readonly ServiceControllerCreateCategoryPath = '/service/category';

  /**
   * Crea una categoria di servizi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceControllerCreateCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  serviceControllerCreateCategory$Response(params: ServiceControllerCreateCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceCategory;
}>> {
    return serviceControllerCreateCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una categoria di servizi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceControllerCreateCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  serviceControllerCreateCategory(params: ServiceControllerCreateCategory$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ServiceCategory;
}> {
    return this.serviceControllerCreateCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ServiceCategory;
}>): BaseResponse & {
'data'?: ServiceCategory;
} => r.body)
    );
  }

  /** Path part for operation `serviceControllerDeleteCategory()` */
  static readonly ServiceControllerDeleteCategoryPath = '/service/category/{id}';

  /**
   * Elimina una categoria e tutti i suoi servizi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceControllerDeleteCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceControllerDeleteCategory$Response(params: ServiceControllerDeleteCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceCategory;
}>> {
    return serviceControllerDeleteCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina una categoria e tutti i suoi servizi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceControllerDeleteCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceControllerDeleteCategory(params: ServiceControllerDeleteCategory$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ServiceCategory;
}> {
    return this.serviceControllerDeleteCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ServiceCategory;
}>): BaseResponse & {
'data'?: ServiceCategory;
} => r.body)
    );
  }

  /** Path part for operation `serviceControllerRenameCategory()` */
  static readonly ServiceControllerRenameCategoryPath = '/service/category/{id}';

  /**
   * Modifica una categoria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceControllerRenameCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  serviceControllerRenameCategory$Response(params: ServiceControllerRenameCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceItem;
}>> {
    return serviceControllerRenameCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica una categoria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceControllerRenameCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  serviceControllerRenameCategory(params: ServiceControllerRenameCategory$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ServiceItem;
}> {
    return this.serviceControllerRenameCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ServiceItem;
}>): BaseResponse & {
'data'?: ServiceItem;
} => r.body)
    );
  }

  /** Path part for operation `serviceControllerCreate()` */
  static readonly ServiceControllerCreatePath = '/service';

  /**
   * Crea un servizio in una categoria.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  serviceControllerCreate$Response(params: ServiceControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceItem;
}>> {
    return serviceControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un servizio in una categoria.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  serviceControllerCreate(params: ServiceControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ServiceItem;
}> {
    return this.serviceControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ServiceItem;
}>): BaseResponse & {
'data'?: ServiceItem;
} => r.body)
    );
  }

  /** Path part for operation `serviceControllerFindOne()` */
  static readonly ServiceControllerFindOnePath = '/service/{id}';

  /**
   * Restituisce un servizio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceControllerFindOne$Response(params: ServiceControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceItemWithCategory;
}>> {
    return serviceControllerFindOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un servizio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceControllerFindOne(params: ServiceControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ServiceItemWithCategory;
}> {
    return this.serviceControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ServiceItemWithCategory;
}>): BaseResponse & {
'data'?: ServiceItemWithCategory;
} => r.body)
    );
  }

  /** Path part for operation `serviceControllerDelete()` */
  static readonly ServiceControllerDeletePath = '/service/{id}';

  /**
   * Elimina un servizio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceControllerDelete$Response(params: ServiceControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceCategory;
}>> {
    return serviceControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un servizio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceControllerDelete(params: ServiceControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ServiceCategory;
}> {
    return this.serviceControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ServiceCategory;
}>): BaseResponse & {
'data'?: ServiceCategory;
} => r.body)
    );
  }

  /** Path part for operation `serviceControllerUpdate()` */
  static readonly ServiceControllerUpdatePath = '/service/{id}';

  /**
   * Modifica un servizio.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  serviceControllerUpdate$Response(params: ServiceControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceItem;
}>> {
    return serviceControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un servizio.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  serviceControllerUpdate(params: ServiceControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: ServiceItem;
}> {
    return this.serviceControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: ServiceItem;
}>): BaseResponse & {
'data'?: ServiceItem;
} => r.body)
    );
  }

}
